<template>
  <v-dialog
    v-model="show"
    persistent
    @keydown.esc="hide"
    width="500"
    v-if="role('admin', 'safetyRepresentative')"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="role('admin', 'safetyRepresentative')"
        v-on="on"
        class="primary accent-4 white--text mt-3 mr-3"
      >
        {{ $t(`dialog.add`) }} {{ $t(`tags.${tagCategory}`) }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t(`dialog.add`) }} {{ $t(`tags.${tagCategory}`) }}
      </v-card-title>
      <v-card-text>
        <div v-if="newTag && similarTags.length" class="my-2">
          {{ $t(`tags.add.similarTags`) }}:
          {{ similarTags.join(", ") }}
        </div>
        <v-form ref="form">
          <v-text-field
            v-model="newTag"
            class=""
            :label="$t(`tags.add.new`) + ` ${$t(`tags.${tagCategory}`)}`"
            hide-details="auto"
            :rules="[rules.required, rules.exists]"
            required
          />
        </v-form>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey" text @click="hide">{{ $t("dialog.cancel") }}</v-btn>

        <v-btn color="primary" text @click="add" :loading="loading">{{
          $t("dialog.add")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

import TagsQuery from "@/graphql/Tags.gql";
import CreateTag from "@/graphql/CreateTag.gql";

export default {
  props: ["tagCategory"],
  data() {
    return {
      loading: false,
      show: false,
      newTag: "",
      rules: {},
    };
  },
  mounted() {
    this.deactiveRules();
  },
  computed: {
    ...mapGetters(["role"]),
    similarTags() {
      return (
        (this.allFilteredTags &&
          this.allFilteredTags.filter((n) =>
            n.toLowerCase().includes(this.newTag.toLowerCase())
          )) ||
        []
      );
    },
  },
  methods: {
    hide() {
      this.deactiveRules();
      this.$refs.form.resetValidation();
      this.newTag = "";
      this.show = false;
    },
    add() {
      this.activateRules();
      this.$nextTick(() => {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.$apollo
            .mutate({
              mutation: CreateTag,
              variables: {
                name: this.newTag,
                category: this.tagCategory,
              },
            })
            .then(() => {
              this.$emit("refresh");
              this.$apollo.queries.allFilteredTags.refresh();
              this.$store.commit("push_global_message", {
                color: "success",
                text: `${this.$t("tags.add.added", {
                  text: `${this.$t("tags." + this.tagCategory)} ${this.newTag}`,
                })}`,
              });
            })
            .catch((err) => {
              this.$store.commit("push_global_message", {
                color: "error",
                text: err,
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    deactiveRules() {
      this.rules = {
        required: () => true,
        exists: () => true,
      };
    },
    activateRules() {
      this.rules = {
        required: () => !!this.newTag || this.$i18n.t("validation.required"),
        exists: () =>
          !this.allFilteredTags
            .map((name) => name.toLowerCase())
            .includes(this.newTag.toLowerCase()) ||
          this.$i18n.t("validation.tagExists"),
      };
    },
  },
  apollo: {
    allFilteredTags: {
      query: TagsQuery,
      update(data) {
        return data.tags
          .filter((t) => t.category == this.tagCategory)
          .map((t) => t.name);
      },
      skip() {
        return !this.show;
      },
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>
